import { render, staticRenderFns } from "./TabContacts.vue?vue&type=template&id=63d0d328&"
import script from "./TabContacts.vue?vue&type=script&lang=js&"
export * from "./TabContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports